<template>
    <div>
        
        <MovieGoBack :text="'电影票详情'"></MovieGoBack>
  
        <!-- 电影票信息 -->
        <ul class="payment-result-content">
        <li>
          订单编号：
          <div class="info">{{orderDetail.order_id || ""}}</div>
        </li>
        <li>
          商品名称：
          <div class="info">电影票 {{orderDetail.total_num || 0}} 张</div>
        </li>
        <li>
          订单详情：
          <div class="info">
            <div>{{orderDetail.movie_name || "电影名称"}}</div> 
            <div>{{orderDetail.cinema_name || "影院"}}</div>
            <div>{{orderDetail.movie_start_time || "观影时间"}}</div>
            <div>{{orderDetail.hall_name || "影厅"}}</div>
            <div>
              <span class="zuowei" v-for="(item, ind) in setLoca(orderDetail.movie_loca)" :key="ind">{{item}}</span>
            </div>
          </div>
        </li>
        <li>
          订单时间：
          <div class="info">{{orderDetail._add_time || ""}}</div>
        </li>
        <li>
          订单金额：
          <div class="info">{{orderDetail.pay_price || 0}}</div>
        </li>
        <li>
          支付状态：
          <div class="info">{{(orderDetail._status && orderDetail._status._title) || ""}}</div>
        </li>
      </ul>
  
      <div class="code">
         <div class="ma">取票码：<span>{{orderDetail.code || '请稍后正在出票中...'}}</span></div>
         <img v-if="orderDetail.code" :src="orderDetail.qrcode_url"  alt='二维码'/>
         
      </div>
  
    </div>
  </template>
  
  <script>
  import MovieGoBack from "@components/MovieGoBack.vue";
  import { movieOrderDetail } from "@api/movie.js";
  import { stringToArray } from "@utils/movie.js";
  export default {
      name:"MovieTicketDetails",
      components:{
          MovieGoBack
      },
      data: function () {
        return {
          orderDetail: {},
          id: this.$route.params.id
        }
      },
      created: function () {
        this.getMovieOrderDetail();
      },
      methods: {
        setLoca: function (val) {
          return stringToArray(val);
        },
        getMovieOrderDetail: function () {
          let id = this.id;
          if (!id) {
            this.$dialog.error("订单不存在");
            this.$router.go(-1);
          }
          movieOrderDetail(id).then((res) => {
            this.orderDetail = res.data;
          }).catch((err) => {
            this.$dialog.error(err.msg);
            // this.$router.go(-1);
          })
        }
      }
  
  }
  </script>
  
  <style scoped>
  .payment-result-content{
      background:#fff;
      padding: .2rem .3rem;
      font-size: .3rem;
  }
  .payment-result-content li{
      display:flex;
      margin: .1rem 0;
  }
  .info{
      margin-left:.3rem;
      flex:1;
  }
  .zuowei{
      margin-right:.2rem;
  }
  .code {
    width: 80%;
    min-height: 1rem;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0 auto;
    padding: .3rem 0;
  }
  .ma {
    width: 4rem;
    margin-bottom: .1rem;
    padding-left: .3rem;
  }
  img {
    width: 4rem;
    height: 4rem;
  }
  </style>